import React from 'react';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectOneModeloFaturamentoTable from './QCXSelectOneModeloFaturamentoTable';

export default function QCXSelectOneModeloFaturamentoFinalFormTable({
  selected = null,
  isConsult,
  handleSubmit,
  handleChange,
  title,
  filterProp,
  columns,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  return (
    <QCXFormStepWizard
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      {...restProps}
    >
      {() => (
        <QCXSelectOneModeloFaturamentoTable
          title={title}
          columns={columns}
          filterProp={filterProp}
          selected={selected}
          isConsult={isConsult}
          handleChange={handleChange}
        />
      )}
    </QCXFormStepWizard>
  );
}
